import Button from "@/components/Button";
import ChangePriceAlert from "@/components/ChangePriceAlert";
import Checkbox from "@/components/Checkbox";
import Column from "@/components/Column";
import Columns from "@/components/Columns";
import Form from "@/components/Form";
import Input from "@/components/Input";
import Layout from "@/components/Layout";
import PageHeader from "@/components/PageHeader";
import SEO from "@/components/SEO";
import Text from "@/components/Text";
import { usePersonalData } from "./hooks/usePersonalData";
import { useEffect } from "react";
import Cookies from "js-cookie";

export default function FormPersonalData() {
  // Cliente que entrou por link de oferta nao tem etapa anterior: a Home
  // redireciona de volta para ca enquanto o cookie existir.
  const hasOfferCookie = !!Cookies.get("offer");
  const {
    showChangePriceAlert,
    currentPrice,
    personalDataSchema,
    saleId,
    bind,
    IsEmailValid,
    phoneBlock,
    autorizarContato,
    cpf,
    formIsValid,
    isLoading,
    pageConfig,
    tel,
    setShowChangePriceAlert,
    handleOnSubmit,
    setEmail,
    handleUserJourney,
    setTel,
    setAutorizarContato,
    setCpf,
    handleOnBlurUserJourney,
    onClickForwardButton,
    data,
    addData,
    setPageConfig,
    isMultProduct,
    isTableOrLess,
  } = usePersonalData();

  useEffect(() => {
    if (!data) {
      return;
    }
    const { found } = data;
    addData({ found });
    const nextRoute = found ? "/type-product" : "/personal-data/complement";

    setPageConfig((oldConfig) => ({ ...oldConfig, nextRoute }));
  }, [data, addData, isTableOrLess, isMultProduct]);

  return (
    <Layout>
      <SEO
        title="Dados Pessoais"
        description="Adicione seus dados pessoais para comprar seu plano TIM"
      />
      {showChangePriceAlert && (
        <ChangePriceAlert
          setShowChangePriceAlert={setShowChangePriceAlert}
          currentPrice={currentPrice}
        />
      )}
      <Column size={12}>
        <PageHeader
          title="Olá! Preencha seus dados para continuar."
          dataIcTitle="sec-omega-comunicacao"
        />
      </Column>
      <Columns
        as={Form}
        className="pt-6"
        alignItems="start"
        justifyContent="center"
        validationSchema={personalDataSchema}
        onSubmit={handleOnSubmit}
      >
        <Column size={12} className="pb-6">
          <input type="hidden" id="user_prefs" name="user_prefs" />
          <input type="hidden" id="user_prefs2" name="user_prefs2" />
          <Input
            name="email"
            inputMode="email"
            autoComplete="email"
            placeholder="E-mail"
            disabled={!!saleId}
            helperText="Receba sua fatura neste e-mail ou acesse o App Meu TIM"
            {...bind}
            ref={bind.ref as React.RefObject<HTMLInputElement>}
            onBlur={() => {
              const v = bind.onBlur();
              setEmail(v);
              if (IsEmailValid) {
                handleUserJourney("email", v);
              }
            }}
          />
        </Column>

        <Column size={12} className="pb-4">
          <Input
            mask="99 99999-9999"
            name="tel"
            type="tel"
            value={tel}
            label="Número atual"
            disabled={!!saleId || !!phoneBlock}
            placeholder="11 99999-9999"
            onChange={(e) => setTel(e.target.value)}
            onBlur={(e) => {
              setTel(e.target.value);
              handleOnBlurUserJourney(e.target.name, e.target.value);
            }}
          />
        </Column>
        <Column size={12} className="pb-4">
          <Checkbox
            name="autorizarContato"
            checked={autorizarContato}
            disabled={!!saleId}
            onChange={(e) => {
              setAutorizarContato(e.target.checked);
              handleUserJourney(e.target.name, e.target.checked);
            }}
          >
            <Text size="xs" className="leading-tight">
              Aceito receber comunicação para continuar minha compra.
            </Text>
          </Checkbox>
        </Column>
        <Column size={12} className="pb-4">
          <Input
            type="tel"
            mask="999.999.999-99"
            name="cpf"
            label="CPF"
            value={cpf}
            disabled={!!saleId}
            placeholder="000.000.000-00"
            loading={isLoading}
            onChange={(e) => {
              setCpf(e.target.value);
              handleOnBlurUserJourney(e.target.name, e.target.value);
            }}
            onBlur={(e) => setCpf(e.target.value)}
          />
        </Column>

        <Column size={12}>
          <Button
            type="submit"
            large
            helperText={!formIsValid ? "todos os campos são obrigatórios" : ""}
            disabled={isLoading || !formIsValid}
            onClick={() => {
              onClickForwardButton(pageConfig.nextRoute);
            }}
          >
            {!formIsValid ? "Preencha os campos para continuar" : "Continuar"}
          </Button>
        </Column>

        {(phoneBlock || !hasOfferCookie) && (
          <Column size={12} className="mt-8">
            <Button
              type="button"
              kind="secondary"
              large
              to={phoneBlock ? "/smart-page" : pageConfig.prevRoute}
              data-ic-trigger="sec-omega-voltar"
            >
              Voltar
            </Button>
          </Column>
        )}
      </Columns>
    </Layout>
  );
}
